import { Trial, TrialEntitlement } from "../types/financial";

// Selectable entitlement options (single source of truth for values + labels)
export const TRIAL_ENTITLEMENT_OPTIONS: {
  value: TrialEntitlement;
  label: string;
}[] = [
  { value: "training", label: "Training" },
  { value: "nutrition", label: "Nutrition" },
];

// Backend defaults a trial with no explicit entitlements to "training"
export const DEFAULT_TRIAL_ENTITLEMENTS: TrialEntitlement[] = ["training"];

// Resolve the entitlements to display for a trial, applying the backend's
// null/empty -> ["training"] fallback in one place.
export const getTrialEntitlements = (
  trial: Pick<Trial, "entitlement_ids">
): TrialEntitlement[] =>
  trial.entitlement_ids && trial.entitlement_ids.length > 0
    ? trial.entitlement_ids
    : DEFAULT_TRIAL_ENTITLEMENTS;

// Friendly label for an entitlement value, falling back to a capitalized raw
// value so unknown/future entitlements still render sensibly.
export const getEntitlementLabel = (value: string): string => {
  const option = TRIAL_ENTITLEMENT_OPTIONS.find((o) => o.value === value);
  if (option) {
    return option.label;
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
};
